import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetInstalledProductsQueryVariables = Types.Exact<{
  property_ids?: Types.InputMaybe<Array<Types.Scalars['uuid']['input']> | Types.Scalars['uuid']['input']>;
}>;


export type GetInstalledProductsQuery = { __typename?: 'query_root', installed_products: Array<{ __typename?: 'installed_products', id: any, warranty_status: string, product_serial?: string | null, partition_id?: string | null, product_id: any, property_id: any, device_status?: string | null, product: { __typename?: 'products', id: any, name: string, make: string, model: string, photo_link?: string | null, product_category: { __typename?: 'product_categories', name: string, label: string } }, property?: { __typename?: 'properties', id: any, name: string, partner_association?: string | null, partner_id?: string | null } | null }> };


export const GetInstalledProductsDocument = gql`
    query getInstalledProducts($property_ids: [uuid!]) {
  installed_products(where: {property_id: {_in: $property_ids}}) {
    id
    warranty_status
    product_serial
    partition_id
    product_id
    product {
      id
      name
      product_category {
        name
        label
      }
      make
      model
      photo_link
    }
    property_id
    property {
      id
      name
      partner_association
      partner_id
    }
    device_status
  }
}
    `;

/**
 * __useGetInstalledProductsQuery__
 *
 * To run a query within a React component, call `useGetInstalledProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstalledProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstalledProductsQuery({
 *   variables: {
 *      property_ids: // value for 'property_ids'
 *   },
 * });
 */
export function useGetInstalledProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetInstalledProductsQuery, GetInstalledProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstalledProductsQuery, GetInstalledProductsQueryVariables>(GetInstalledProductsDocument, options);
      }
export function useGetInstalledProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstalledProductsQuery, GetInstalledProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstalledProductsQuery, GetInstalledProductsQueryVariables>(GetInstalledProductsDocument, options);
        }
export function useGetInstalledProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInstalledProductsQuery, GetInstalledProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInstalledProductsQuery, GetInstalledProductsQueryVariables>(GetInstalledProductsDocument, options);
        }
export type GetInstalledProductsQueryHookResult = ReturnType<typeof useGetInstalledProductsQuery>;
export type GetInstalledProductsLazyQueryHookResult = ReturnType<typeof useGetInstalledProductsLazyQuery>;
export type GetInstalledProductsSuspenseQueryHookResult = ReturnType<typeof useGetInstalledProductsSuspenseQuery>;
export type GetInstalledProductsQueryResult = Apollo.QueryResult<GetInstalledProductsQuery, GetInstalledProductsQueryVariables>;